"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CardFooter", {
    enumerable: true,
    get: function() {
        return CardFooter;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const CardFooter = (param)=>{
    let { children, ...props } = param;
    const { colors, spacers } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        className: _style.default.dynamic([
            [
                "cb4b866978446b88",
                [
                    colors.border,
                    spacers.s3
                ]
            ]
        ]) + " " + (props && props.className != null && props.className || "")
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "cb4b866978446b88",
        dynamic: [
            colors.border,
            spacers.s3
        ]
    }, "div.__jsx-style-dynamic-selector{border-top:solid 1px ".concat(colors.border, ";padding:").concat(spacers.s3, "}")));
};

//# sourceMappingURL=CardFooter.js.map